// FILE: src/utils/searchHelpers.js
/**
 * Helpers to sanitize titles and produce keywords.
 */

export function sanitizeTitle(raw) {
  if (!raw) return "";
  let s = String(raw).trim();

  // If someone accidentally stored "Title /product/ID" or "Title /product/ID, ...", remove the " /product/..." tail.
  // Remove common path remnants like " /product/ID", " /farm/ID" and any trailing IDs.
  s = s.replace(/\s*\/\s*(product|farm|post|item|p)\/[A-Za-z0-9_-]+(\b.*)?$/i, "");

  // If the title accidentally contains full path with spaces "Carrots /product/LBsJS...", drop everything after the first " /"
  s = s.replace(/\s*\/\s*.+$/, "");

  // Remove trailing IDs like " - LB12345" or "(LB12345)" commonly appended by some exporters
  s = s.replace(/\s*[-–—]\s*[A-Za-z0-9_-]{4,}\b/, "");
  s = s.replace(/\s*\([A-Za-z0-9_-]{4,}\)\s*$/, "");

  // Trim again and collapse multiple spaces
  s = s.replace(/\s{2,}/g, " ").trim();

  // If the result looks like a path (starts with /), fallback to empty
  if (s.startsWith("/")) return "";

  return s || String(raw).trim();
}

export function tokenizeToKeywords(text, max = 20) {
  if (!text) return [];
  const words = String(text)
    .toLowerCase()
    .split(/[^a-z0-9]+/i)
    .filter(Boolean);
  const uniq = Array.from(new Set(words));
  return uniq.slice(0, max);
}
